export const GET_USER = "GET_USER";
export const REMOVE_USER = "REMOVE_USER";
export const EDIT_ACCOUNT = "EDIT_ACCOUNT"
export const EDIT_STATUS = "EDIT_STATUS"
export const EMAIL_FETCH_USER = "EMAIL_FETCH_USER"
export const ERROR_HANDLING = 'ERROR_HANDLING'
export const FETCH_USER_BY_ID = 'FETCH_USER_BY_ID'
export const SET_USER = "SET_USER"
export const UPLOAD_PROFILE_PHOTO_SUCCESS = 'UPLOAD_PROFILE_PHOTO_SUCCESS'
export const FETCH_FOLLOWERS = 'FETCH_FOLLOWERS'
export const FETCH_FOLLOWINGS = 'FETCH_FOLLOWINGS'
export const ADD_PROFILE_TO_VIEWS = 'ADD_PROFILE_TO_VIEWS'
export const REMOVE_PROFILE_FROM_VIEWS = 'REMOVE_PROFILE_FROM_VIEWS'
export const INPUT_NEW_INFO = 'INPUT_NEW_INFO'
export const TOGGLE_LOGIN = 'TOGGLE_LOGIN'
export const TOGGLE_SIGNUP = 'TOGGLE_SIGNUP'
